import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';

import 'Components/Carousel/FeaturedCarousel/PanelComponents/BadgeSlash.scss';

export default function BadgeSlash({ type, releaseDate, earlyAccessDate, freeToPlay }) {
  let earlyAccess = false;
  if (earlyAccessDate) earlyAccess = true;

  const types = ['starDeal', 'flashDeal', 'preOrder', 'justLaunched', 'bundle', 'categorySale', 'franchiseSale', 'publisherSale', 'siteWideSale'];
  return (
    <div className={`BadgeSlash BadgeSlash--${type}`}>
      <div className="BadgeSlash__label">
        {type === 'starDeal' &&
          <React.Fragment>
            <img loading="lazy" src="https://cdn.fanatical.com/production/brand/star-deal-icon-dark.svg" alt="Star Deal" />
            <FormattedMessage id="BadgeSlash.label.stardeal" defaultMessage="Star Deal" />
          </React.Fragment>
        }
        {type === 'flashDeal' &&
          <FormattedMessage id="BadgeSlash.label.flashdeal" defaultMessage="Flash Deal" />
        }
        {type === 'preOrder' && !earlyAccess &&
          <FormattedMessage
            id="BadgeSlash.label.preorder"
            defaultMessage="Releases {date}"
            values={{
              date: <FormattedDate value={releaseDate * 1000} month="short" day="2-digit" />,
            }}
          />
        }
        {type === 'preOrder' && earlyAccess &&
          <FormattedMessage
            id="BadgeSlash.label.earlyaccess"
            defaultMessage="Available {date}"
            values={{
              date: (earlyAccessDate * 1000) > Date.now() ?
                <FormattedDate value={earlyAccessDate * 1000} month="short" day="2-digit" /> :
                <FormattedMessage id="BadgeSlash.label.earlyaccess,now" defaultMessage="Now" />,
            }}
          />
        }
        {type === 'justLaunched' &&
          <React.Fragment>
            {window.locale === 'en' ?
              <FormattedMessage id="BadgeSlash.label.just-launched" defaultMessage="Just Launched" />
              :
              <FormattedMessage id="BadgeSlash.label.new" defaultMessage="New" />
            }
          </React.Fragment>
        }
        {type === 'bundle' &&
          <FormattedMessage id="BadgeSlash.label.bundle" defaultMessage="Exclusive Bundle" />
        }
        {type === 'categorySale' &&
          <FormattedMessage id="BadgeSlash.label.category" defaultMessage="Category Sale" />
        }
        {type === 'siteWideSale' &&
          <FormattedMessage id="BadgeSlash.label.sitewide" defaultMessage="Sitewide Sale" />
        }
        {type === 'publisherSale' &&
          <FormattedMessage id="BadgeSlash.label.publishersale" defaultMessage="Publisher Sale" />
        }
        {type === 'franchiseSale' &&
          <FormattedMessage id="BadgeSlash.label.franchisesale" defaultMessage="Franchise Sale" />
        }

        {freeToPlay &&
          <FormattedMessage
            id="BadgeSlash.label.downloadandplay"
            defaultMessage="Download and Play"
          />
        }

        {!types.includes(type) && !freeToPlay &&
          <FormattedMessage
            id="BadgeSlash.label.buynow"
            defaultMessage="Buy Now"
          />
        }
      </div>
      <div className="BadgeSlash__angle" />
    </div>
  );
}

BadgeSlash.propTypes = {
  type: PropTypes.string,
  releaseDate: PropTypes.number,
  earlyAccessDate: PropTypes.number,
  freeToPlay: PropTypes.bool,
};

BadgeSlash.defaultProps = {
  type: '',
  releaseDate: 0,
  earlyAccessDate: 0,
  freeToPlay: false,
};
